import i18n from 'utils/i18n'
import React from "react";
import { StyleSheet, View } from 'react-native';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import _ from "lodash";
import { IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import TimeslotIcon from 'components/molecules/TimeslotIcon'
import { colorList } from 'utils/colors'
import ThemedBlock from 'components/atoms/ThemedBlock'


const HomeMoreDebugIconsScene = () => {
	
	const iconCombinations = [];
	const iconsByName = [];
	const iconsRandom = [];
	
	const combinations = [
		[ IconTimeslotConstants.WORKPLACE, IconTimeslotConstants.DESKTOP ],
		[ IconTimeslotConstants.WORKPLACE, IconTimeslotConstants.WHEELCHAIR ],
		[ IconTimeslotConstants.WORKPLACE, IconTimeslotConstants.PHONE ],
		[ IconTimeslotConstants.WORKPLACE, IconTimeslotConstants.HEADPHONES ],
		[ IconTimeslotConstants.MEETING_ROOM, IconTimeslotConstants.VIDEO ],
		[ IconTimeslotConstants.TV, IconTimeslotConstants.PLAYSTATION ],
		[ IconTimeslotConstants.CAR, IconTimeslotConstants.PARKING ],
		[ IconTimeslotConstants.TRUCK, IconTimeslotConstants.PARKING ],
		[ IconTimeslotConstants.BICYCLE, IconTimeslotConstants.ELECTRICITY, IconTimeslotConstants.PARKING ]
	]
	
	_.forEach( combinations, ( combination ) => {
		let overWriteProperties = {
			icon: combination[ 0 ],
			background_color: colorList.ORANGE.primary,
			sub_icon: combination[ 1 ],
			secondary_sub_icon: combination[ 2 ]
		};
		
		iconCombinations.push(
			<View style={ staticStyles.viewWidth50Height50 }>
				<TimeslotIcon
					timeslot={ {
						kind: 'test',
						type: 'test'
					} }
					overWriteProperties={ overWriteProperties }
				/>
			</View>
		);
	});
	
	_.forEach( [ false, true ], ( hasSubIcon ) => {
		_.forEach( [ colorList.ORANGE.primary, colorList.GREEN.primary, colorList.BLACK.primary, colorList.GREY.primary ], ( backgroundColor ) => {
			_.forEach( IconTimeslotConstants, ( name ) => {
				const overWriteProperties = {
					icon: name,
					background_color: backgroundColor,
					icon_color: backgroundColor !== colorList.GREY.primary ? colorList.WHITE.primary : colorList.BLACK.primary,
					sub_icon: hasSubIcon ? name : null
				};
				
				iconsByName.push(
					<View
						style={ staticStyles.viewWidth50Height50 }>
						
						<TimeslotIcon
							timeslot={ {
								kind: 'test',
								type: 'test'
							} }
							overWriteProperties={ overWriteProperties }
						/>
					</View>
				);
			});
		})
	});
	
	// random combinations
	for( let i = 0; i < 300 ; i++ ){
		// get random value from IconTimeslotConstants
		let randomIcon = _.sample( IconTimeslotConstants );
		let randomSubIcon = i > 100 ? _.sample( IconTimeslotConstants ) : null;
		let randomSecondarySubIcon = i > 200 ? _.sample( IconTimeslotConstants ) : null;
		let backgroundColor =  _.sample( colorList.ICONS );
		
		const overWriteProperties = {
			icon: randomIcon,
			background_color: backgroundColor,
			icon_color: 'auto',
			sub_icon: randomSubIcon,
			secondary_sub_icon: randomSecondarySubIcon
		};
		
		iconsRandom.push(
			<View
				style={ staticStyles.viewWidth50Height50}>
				
				<TimeslotIcon
					timeslot={{
						kind: 'test',
						type: 'test'
					}}
					overWriteProperties={ overWriteProperties }
				/>
			</View>
		);
	}
	
	const blockViewStyle = staticStyles.blockViewStyleFlexDirectionRowFlexWrapWrap
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				title={ i18n.t( 'debug_ui.icons_title' ) }>
				
				<ThemedBlock shadow>
					<View style={ blockViewStyle }>
						{ iconCombinations }
					</View>
				</ThemedBlock>
				
				<ThemedBlock shadow>
					<View style={ blockViewStyle }>
						{ iconsByName }
					</View>
				</ThemedBlock>
				
				<ThemedBlock shadow>
					<View style={ blockViewStyle }>
						{ iconsRandom }
					</View>
				</ThemedBlock>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const staticStyles = StyleSheet.create({
	viewWidth50Height50: {
		width: 50,
		height: 50,
		flex: 0,
		margin: 6,
	},
	blockViewStyleFlexDirectionRowFlexWrapWrap: {
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
});

export default HomeMoreDebugIconsScene
